module.exports = __webpack_public_path__ + "static/media/file-prescription.135ffda5.svg";